/*
 * Copyright (C) 2025.  SimpliCity Digital Inc - All Rights Reserved
 */

import { CmsConfig } from "cms/config";

const PreviewGuard = (props) => {

    const children = props?.children;
    const isPreview = CmsConfig.isPreview;

    if (!isPreview) {
        return null;
    }
    return (
        <>{children}</>
    );
};

export { PreviewGuard };
